import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  blobContainer: {
    display: "flex",
    alignItems: "flex-end",
    marginBottom: "12px",
  },
  "@keyframes bounce": {
    "0%": { WebkitTransform: "translateY(0px)", transform: "translateY(0px)" },
    "45%": {
      WebkitTransform: "translateY(5px)",
      transform: "translateY(5px)",
    },
    "55%": {
      WebkitTransform: "translateY(5px)",
      transform: "translateY(5px)",
    },
    "100%": {
      WebkitTransform: "translateY(0px)",
      transform: "translateY(0px)",
    },
  },
  blob: {
    width: "0.28em !important",
    height: "0.28em",
    margin: "0 0.15em",
    background: "rgba(25, 25, 25, 0.85)",
    borderRadius: "50%",
    boxShadow: "0 0 1rem rgba(0, 0, 0, 0.25)",
    animationDuration: "1.5s",
    animationIterationCount: "infinite",
    animationName: "$bounce",
    animationTimingFunction: "ease-in-out",
  },
  blob1: { composes: "$blob", animationDelay: "0s" },
  blob2: { composes: "$blob", animationDelay: "0.07s" },
  blob3: { composes: "$blob", animationDelay: "0.14s" },
});

const LoadingSprite = () => {
  const styles = useStyles();
  return (
    <div className={styles.blobContainer}>
      <div className={styles.blob1} />
      <div className={styles.blob2} />
      <div className={styles.blob3} />
    </div>
  );
};

export default LoadingSprite;
